/**
 * ES Invoice – traducciones del proyecto L'Invoice (namespace translation)
 * El detalle de la UI de factura usa el namespace 'einvoice'
 */

import menu from "./menu.js";

export default {
  ...menu,
};
